// ============================================================
// caseEntryStyles.tsx — the case-entry modals' shared field / label / button
// classes (the approved casevo-case-entry-modals.html mockup). One copy, used
// by NewCaseModal, NewCaseForClientModal, ClaimTypeFields and
// DuplicateCaseDialog (was duplicated in each).
// ============================================================
import React from 'react'

// .in field = the quick-view's input (CaseQuickViewModal.tsx:71) + the
// mockup's focus halo.
export const FIELD =
  'w-full border border-casevo-border rounded-lg px-3 py-2.5 text-sm bg-casevo-input dark:bg-[#1f2e26] text-casevo-forest ' +
  'placeholder:text-casevo-text-soft focus:outline-none focus:border-casevo-mid ' +
  'focus:shadow-[0_0_0_3px_color-mix(in_srgb,var(--casevo-mid)_18%,transparent)]'
export const FIELD_ERR = FIELD.replace('border-casevo-border', 'border-red-300 dark:border-red-400/60')
// .f label — 12px semibold, required * in danger, <small> soft.
export const LBL = 'block text-[12px] font-semibold text-casevo-forest mb-[5px]'
export const REQ = <em className="not-italic text-casevo-danger ml-[2px]" aria-hidden="true">*</em>
export const SMALL = 'font-medium text-casevo-text-soft ml-[4px]'
// .lbl section eyebrow — 10.5px / .16em / uppercase / soft.
export const SEC = 'flex items-center gap-2 text-[10.5px] tracking-[0.16em] uppercase text-casevo-text-soft font-semibold mb-[10px]'
export const HINT = 'text-[11.5px] text-casevo-text-soft mt-[5px]'
export const BTN_CANCEL =
  'inline-flex items-center text-sm font-medium rounded-lg px-5 py-2.5 border border-casevo-border text-casevo-mid hover:border-casevo-mid hover:text-casevo-forest transition-colors focus:outline-none casevo-focus disabled:opacity-50'
